import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './index.css';

const CommonModal = ({
  show,
  handleClose,
  footer,
  size = 'sm',
  leftMargin = '0',
  children,
  conditionalClass = '',
  showfooter = true,
}: any) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={`dialog_section ${conditionalClass}`}
      size={size}
      style={{ marginLeft: leftMargin }}
    >

      <Modal.Body>{children}</Modal.Body>
      {showfooter && <Modal.Footer>
        {footer ? (
          footer
        ) : (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </>
        )}
      </Modal.Footer>}
    </Modal>
  );
};
export default CommonModal;
